import { useQuery } from '@fv/client-core'
import type {
  ComparableLoadsOptions,
  ComparableLoadsResult,
} from '@fv/models/admin'

import { adminFetch } from '@/utils'

export type ComparableLoadsQuery = Pick<
  ComparableLoadsOptions,
  'bookedWindow' | 'pickupWindow' | 'laneToleranceRadiusMiles'
>

type QueryOpts = {
  enabled?: boolean
}

const getComparableLoads = async (
  loadId: string,
  query: ComparableLoadsQuery,
) => {
  return await adminFetch<ComparableLoadsResult>(
    `/loads/${loadId}/comparables`,
    {
      query,
    },
  )
}

export const useComparableLoads = (
  loadId: string,
  query: ComparableLoadsQuery,
  opts?: QueryOpts,
) => {
  return useQuery({
    queryKey: ['comparable-loads', loadId, query],
    queryFn: () => getComparableLoads(loadId, query),
    enabled: opts?.enabled ?? true,
    staleTime: Infinity,
  })
}
